// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ExitSvg from '@rsuite/icon-font/lib/action/Exit';
var Exit = createSvgIcon({
  as: ExitSvg,
  ariaLabel: 'exit',
  category: 'action',
  displayName: 'Exit'
});
export default Exit;